// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyAVx9abpEn-io7HkXjycpfQcH4-SxI6MHE",
  authDomain: "ia-project-87522.firebaseapp.com",
  projectId: "ia-project-87522",
  storageBucket: "ia-project-87522.firebasestorage.app",
  messagingSenderId: "323237788745",
  appId: "1:323237788745:web:5fa90535813982cbfc5398",
  measurementId: "G-QN4EEVRQT9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);